import { Check, Copy } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { copyText } from "../clipboard";

export function CopyablePublicId({ value, label = "ID", className = "" }: { value: string | null; label?: string; className?: string }) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<number | null>(null);
  useEffect(() => () => { if (timer.current !== null) window.clearTimeout(timer.current); }, []);
  if (!value) return <span className={`public-id public-id--unassigned ${className}`.trim()}>{label} not assigned</span>;
  const copy = async () => {
    await copyText(value);
    setCopied(true);
    if (timer.current !== null) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setCopied(false), 1600);
  };
  return <button type="button" className={`public-id ${className}`.trim()} onClick={() => void copy()} aria-label={`Copy ${label} ${value}`} title={`Copy ${value}`}>
    <span>{label}: {value}</span>{copied ? <Check size={13} aria-hidden="true" /> : <Copy size={13} aria-hidden="true" />}
    <span className="sr-only" aria-live="polite">{copied ? `${value} copied` : ""}</span>
  </button>;
}
